import { paramCase } from 'change-case';

export const objectToCss = (stylesObject: Record<string, any>) => {
  let res = '';
  for (const propName in stylesObject) {
    res += `${paramCase(propName)}: ${stylesObject[propName]};`;
  }
  return res;
};
